import 'app/modules/datetime';

var expandable = function (el) {
    $(el).on('click', '.control', function (e) {
        e.preventDefault();

        var currentTarget = $(e.currentTarget);
        currentTarget.parent().toggleClass('expanded');
    });
};

var stars = function (el) {
    var checkSelected = function ($el) {
        if ($el.hasClass('current')) {
            // Enable ability to clear selection
            $el.prop('checked', false);
            $el.removeClass('current');
            $el.siblings('label').removeClass('checked');
        } else {
            addCurrent($el);
        }
    };

    var addCurrent = function ($el) {
        // CSS doesn't have previous selectors so we need to handle
        // applying classes to the previous elements.
        $el.prop('checked', true);
        $el.siblings('input').removeClass('current');
        $el.addClass('current');
        $el.nextAll('label').removeClass('checked');
        $el.prevAll('label').addClass('checked');
        $el.siblings('label[for="' + $el.attr('id') + '"]').addClass('checked');
    };

    $(el)
        .find('input[type="radio"]')
        .each(function (key, input) {
            // Mark active star and highlight previous stars.
            if ($(input).hasClass('selected') || $(input).prop('checked')) {
                addCurrent($(input));
            }
        });

    $(el).on('click', 'label', function (e) {
        e.preventDefault(); // Prevent radio click event.
        checkSelected($(this).siblings('#' + $(this).attr('for')));
    });
};

$(function () {
    stars('.stars');
    expandable('.rationale');
    $('span.gmttime').dateTime();
});



// WEBPACK FOOTER //
// ./src/web/js/presentation/presentation.js